import "./theme.css";
import type { Brand } from "../types";
import { meta } from "./meta";
import { fluent } from "./fluent";
import { SplashMark } from "./SplashMark";
import logo from "./assets/logo.svg";
import avatar from "./assets/avatar.svg";
import clearChatIcon from "./assets/clear-chat.svg";
import About from "./pages/About";
import TermsOfUse from "./pages/TermsOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";

export const brand: Brand = {
    ...meta,
    logo,
    avatar,
    clearChatIcon,
    tagline: "What ethics related question can I help answer?",
    exampleQuestions: [
        "I have a second job outside of my federal position—do I need to report it?",
        "Do I need to disclose investments in mutual funds in my financial disclosure?",
        "Are there reporting requirements for selling stocks during my employment at the agency?",
        "What restrictions apply if I leave my federal job for employment in the private sector?"
    ],
    domainNoun: { singular: "topic", plural: "topics" },
    domainUrlParam: "topic",
    tour: {
        welcomeParagraphs: [
            "Ask Ethos is an AI-powered chatbot designed to provide you with answers and access to ethics related inquiries and resources.",
            "Ask Ethos curates its information from publicly available gov't websites, forms, regulations, and documentation. It is not designed to respond to queries outside of the scope of this dataset, or make ethics reporting determinations."
        ],
        clearChat:
            "Click the new message icon to clear the chat. Ask Ethos uses the context of your current chat to provide better responses. It is recommended to clear the chat when asking a question on a new or unrelated topic."
    },
    splash: {
        Mark: SplashMark,
        background: "linear-gradient(160deg, #0b1a22 0%, #122834 50%, #1b4052 100%)",
        accent: "#5592ae",
        fontFamily: '"IBM Plex Sans", sans-serif',
        phrases: ["Connecting to Ask Ethos...", "Loading resources...", "Preparing your assistant...", "Almost ready..."]
    },
    colors: {
        navMenuIcon: "#cadfe9",
        domainPickerText: "#172028",
        installPromptBackground: "#122834",
        installPromptAccent: "#256482"
    },
    features: { installApp: false, smsTerms: false },
    about: { Page: About },
    pages: { TermsOfUse, PrivacyPolicy },
    fluent
};
